import { render, staticRenderFns } from "./DetallePacienteUnificacion.vue?vue&type=template&id=4250ccd1&scoped=true"
import script from "./DetallePacienteUnificacion.vue?vue&type=script&lang=js"
export * from "./DetallePacienteUnificacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4250ccd1",
  null
  
)

export default component.exports